import React from 'react';

export const REGISTER_URL = 'https://card.equiliberty.com/register';

/** "Join the Community" call to action: opens the EQ Card sign-up in a new tab. */
export default function JoinCommunityButton({
  className = '',
  style,
  children = 'Join the Community',
}) {
  return (
    <a
      href={REGISTER_URL}
      target='_blank'
      rel='noopener noreferrer'
      className={className}
      style={style}
    >
      {children}
    </a>
  );
}
